<script setup lang="ts">
import { Dialog } from "../../../../base-components/Headless";
import Button from "../../../../base-components/Button";
import { ref } from "vue";
import Lucide from "../../../../base-components/Lucide";
import { useMensajesStore } from "../../../../services/mensajes";
import LoadingIcon from "../../../../base-components/LoadingIcon";
import { useUsuariosInvitacionesStore } from "../../../../services/usuariosInvitaciones";
import { UsuarioSistemaInvitacion } from "@fixeduy/restaurantestypes";

interface Props {
  usuario: UsuarioSistemaInvitacion;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "cerrarInvitacion"): void;
}>();
const usuariosSistemasInvitacionesStore = useUsuariosInvitacionesStore();
const mensajesStore = useMensajesStore();

const cargando = ref(false);

const handleEnviarMail = async () => {
  cargando.value = true;
  const resultado = await usuariosSistemasInvitacionesStore.enviarMail(
    props.usuario
  );

  if (resultado.exito == true) {
    mensajesStore.mostrarToast(
      "Invitación enviada",
      `Fue enviada por mail a ${props.usuario.mail}`,
      mensajesStore.mensajeType.exito
    );
  } else {
    mensajesStore.mostrarToast(
      "Error enviando invitación",
      `Hubo un error enviando a ${props.usuario.mail}, por las dudas revisa que sea correcto `,
      mensajesStore.mensajeType.error
    );
  }

  emit("cerrarInvitacion");
};
</script>

<template>
  <Dialog
    :open="true"
    @close="
      () => {
        emit('cerrarInvitacion');
      }
    "
    size="lg"
  >
    <Dialog.Panel>
      <Dialog.Description class="">
        <div class="p-5 text-center">
          <Lucide icon="MailPlus" class="w-16 h-16 mx-auto mt-3 text-success" />
          <div class="mt-5 text-3xl">Confirma reenviar mail invitación</div>
          <div class="mt-5 text-slate-900">
            ¿Seguro que quieres volver a enviar el mail de invitación a
            {{ usuario.nombre }} - <strong>{{ usuario.mail }}</strong
            >?
          </div>
        </div>
      </Dialog.Description>
      <Dialog.Footer>
        <div v-if="!cargando" class="flex text-right">
          <div class="flex-1 text-left">
            <Button
              variant="secondary"
              class="mb-2 mr-3"
              @click="
                () => {
                  emit('cerrarInvitacion');
                }
              "
            >
              Cancelar</Button
            >
          </div>

          <div class="flex-1">
            <Button
              variant="primary"
              class="mb-2 mr-1"
              @click="handleEnviarMail"
            >
              Confirmar
            </Button>
          </div>
        </div>
        <div v-else class="flex justify-end my-6">
          <div class="mx-auto">
            <LoadingIcon icon="oval" class="w-8 h-8" />
          </div>
        </div>
      </Dialog.Footer>
    </Dialog.Panel>
  </Dialog>
</template>
